<template>
    <div class="publication">
        <!-- content wrapper -->
        <div class="publication-body">
            <div class="container-limit">
                <PublicationAuthor :result="params.data.author"/>
<!--                <PublicationSubscription/>-->
            </div>
        </div>
        <div class="container-limit">
            <Reviews :replies="replies" :article="{id: params.data.id, params: params.data.repliesFormParams}"/>
        </div>
    </div>
</template>

<script>
import { computed, provide} from "vue";
import PublicationInform from "./PublicationInform";
import Reviews from "../../Reviews/Reviews/Reviews";
import PublicationAuthor from "./PublicationAuthor";

export default {
    name: 'Publication',
    props: ['params'],
    components: {
        PublicationAuthor,
        Reviews,
        PublicationInform
    },
    setup(props,ctx) {
        provide('translates', props.params.messages);
        const replies = computed(() => {
            return props.params.data?.replies || {}
        })

        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('type', 'application/ld+json');
        let shemaOrgData = {
          "@context": "http://schema.org",
          "@type": "BlogPosting",
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": props.params.data?.absoluteLink
          },
          "headline": props.params.data?.name,
          "image": [
            props.params.data?.absolutePicture
          ],
          "datePublished": props.params.data?.dateAdd,
          "dateModified": props.params.data?.dateModef,
          "author": {
            "@type": "Person",
            "name": props.params.data?.author.name
          },
          "publisher": {
            "@type": "Organization",
            "name": props.params.data?.publisher.name,
            "logo": {
              "@type": "ImageObject",
              "url": props.params.data?.publisher.logo,
            }
          },
          "description": props.params.data?.previewText
        };


      recaptchaScript.innerHTML = JSON.stringify(shemaOrgData);
      document.body.appendChild(recaptchaScript);
      return {
          replies,
      }
    },

}
</script>

<style lang="scss" scoped>
.publication {
    :deep {
        .publication-picture-slider {
            margin: 54px 0;
            @include mobile {
                margin: 60px 0 60px 15px;
            }
        }

        .container-limit {
            margin: 0 auto;
            max-width: 922px + 30px;
            padding: 0 15px;

            & > img {
                display: block;
                margin: 53px 0;
                border-radius: 6px;
                @include tablet {
                    margin: 23px 0;
                }
                @include mobile {
                    margin: 60px 0;
                }
            }
        }
    }
}

.publication-hero {
    width: 100%;
    margin-bottom: 85px;

    @include tablet {
        margin-bottom: 50px;
    }
}

.publication-body {
    :deep {
        & > img {
            display: block;
            margin-bottom: 85px;
            border-radius: 6px;
            margin-top: 61px;
            width: 100%;
            @include tablet {
                margin-top: 56px;
                margin-bottom: 56px;
            }
            @include mobile {
                margin-bottom: 60px;
                margin-top: 60px;
            }
        }

        .big {
            font-weight: 400;
            font-size: 22px;
            line-height: 32px;
        }

        p {
            font-size: 18px;
            line-height: 28px;
        }

        h2 {
            font-size: 32px;
            line-height: 38px;
            margin-bottom: 22px;
            @include tablet {
                font-size: 22px;
                line-height: 28px;
                margin-bottom: 18px;
            }
        }

        b {
            font-weight: 700;
        }

        blockquote {
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: 400;
            font-size: 22px;
            line-height: 32px;
            padding: 29px 38px;
            border-left: 3px solid #6367A7;
            margin: 54px 0;
            @include tablet {
                padding: 28px;
                margin: 60px 0;
            }
        }

        ul {
            padding-left: 18px;
            margin-block-start: 2rem;

            li {
                padding-left: 26px;
                margin-bottom: 54px;
                font-size: 18px;
                line-height: 28px;
                @include tablet {
                    padding-left: 12px;
                }
            }
        }

        table {
            border-collapse: collapse;
            width: 100%;
            margin: 34px 0 56px;

            caption {
                font-size: 16px;
                line-height: 26px;
                color: #68737D;
                text-align: start;
                margin-bottom: 13px;
            }

            tr {
                background-color: #E9EBED;
                border-radius: 6px;
                font-size: 16px;
                line-height: 50px;

                &:nth-child(2n) {
                    background-color: #fff;
                }
            }

            td {
                padding: 0 22px;
            }
        }

        .publication-member-slider {
            @include mobile {
                width: calc(100vw - 15px);
            }
        }
    }
}
</style>